import React from 'react';
interface FooterProps {
  lang: 'en' | 'es';
}
export const Footer: React.FC<FooterProps> = ({
  lang
}) => {
  return <footer className="bg-[#050505] py-12 px-6 border-t border-border/50" data-id="element-13">
      <div className="max-w-4xl mx-auto text-center flex flex-col items-center gap-4" data-id="element-14">
        <p className="text-[#555555] text-sm" data-id="element-15">
          Simon Alvarado <span className="mx-2" data-id="element-16">|</span> simonpro.vip{' '}
          <span className="mx-2" data-id="element-17">|</span> Miami, FL
        </p>
        <p className="text-[#555555] text-sm" data-id="element-18">
          Bilingual Service — EN / ES <span className="mx-2" data-id="element-19">|</span> All Makes
          & Models <span className="mx-2" data-id="element-20">|</span> New & Pre-Owned
        </p>
        <p className="text-[#333333] text-xs mt-4" data-id="element-21">
          © 2026 Simon Pro. All rights reserved.
        </p>
      </div>
    </footer>;
};